module.exports = __webpack_public_path__ + "static/media/about-bg-example-2.c42b5a7a.png";